// Gemeinsame Bausteine der Einkaufs-Verträge. Bestände und Bedarfe stehen in Tausendstel der BASISEINHEIT des
// Artikels (1 Flasche = 1000), Bestellmengen in Tausendstel der BESTELLEINHEIT (1 Palette = 1000). Geld in Cent netto.
import { zId } from '@shared/ids'
import { z } from 'zod'

/** Kalendertag 'YYYY-MM-DD' (Europe/Berlin). */
export const zDay = z.iso.date({ error: 'Bitte ein gültiges Datum eingeben.' })

/** Menge in Tausendstel eines Gebindes, größer als null. */
export const zUnitQty = z
  .int({ error: 'Bitte eine Menge eingeben.' })
  .min(1, { error: 'Die Menge muss größer als 0 sein.' })
  .max(1_000_000_000, { error: 'Die Menge ist zu groß.' })

export const zUnitQtyOrZero = z
  .int({ error: 'Bitte eine Menge eingeben.' })
  .min(0, { error: 'Die Menge darf nicht negativ sein.' })
  .max(1_000_000_000, { error: 'Die Menge ist zu groß.' })

export const zReason = z
  .string({ error: 'Bitte geben Sie einen Grund an.' })
  .trim()
  .min(3, { error: 'Bitte geben Sie einen Grund an (mindestens 3 Zeichen).' })
  .max(500, { error: 'Der Grund ist zu lang (höchstens 500 Zeichen).' })

export const zNote = z.string().trim().max(500, { error: 'Die Notiz ist zu lang (höchstens 500 Zeichen).' }).nullish()

export const zLocationRef = z.object({ id: zId, code: z.string(), name: z.string() })
export const zSupplierRef = z.object({ id: zId, number: z.string().nullable(), name: z.string() })
export const zPerson = z.object({ id: zId, name: z.string() })

/** Gebinde eines Artikels für Anzeige und Umrechnung. */
export const zUnitInfo = z.object({
  id: zId,
  /** Kurzform: „Pal“, „Ka“ */
  short: z.string(),
  /** Basismenge je Gebinde in Tausendstel (Palette mit 40 Kästen zu 20 Flaschen = 800000) */
  baseQty: z.int(),
})
export type UnitInfo = z.output<typeof zUnitInfo>

export const ORDER_TYPE = 'purchase_order'
export const INVOICE_TYPE = 'supplier_invoice'
/** Lieferantengutschrift (AP8b) */
export const CREDIT_NOTE_TYPE = 'supplier_credit_note'
/** Belegart des Moduls Bestand, aus der und zu der der Einkauf ableitet */
export const GOODS_RECEIPT_TYPE = 'goods_receipt'
